var _path, _g, _defs;
const _excluded = ["title", "titleId"],
  _excluded2 = ["title", "titleId"],
  _excluded3 = ["className", "color", "size", "pointer"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef, memo } from "react";
import { hooks } from '@approvalmax/utils';
const SVG = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 16,
    fill: "none",
    viewBox: "0 0 22 16",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#179a)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "180b",
    width: 22,
    height: 16,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M19.905 0H2.095C.938 0 0 .955 0 2.133v11.734C0 15.045.938 16 2.095 16h17.81C21.062 16 22 15.045 22 13.867V2.133C22 .955 21.062 0 19.905 0"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#180b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#006C3D",
    d: "M19.905 0H2.095C.938 0 0 .955 0 2.133v11.734C0 15.045.938 16 2.095 16h17.81C21.062 16 22 15.045 22 13.867V2.133C22 .955 21.062 0 19.905 0"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M10.476 7.467H0v1.066h10.476V16h1.048V8.533H22V7.467H11.524V0h-1.048z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FDD200",
    fillRule: "evenodd",
    d: "M9.429 6.4v1.067h1.047V0H9.43zH0v1.067h10.476V6.4zm1.047 1.067H22V6.4H9.429v1.067zV6.4H9.43V16h1.047z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M12.571 9.6V8.533h-1.047V16h1.047zH22V8.533H11.524V9.6zM0 8.533h13.619V9.6H0zM11.524 0h1.047v9.6h-1.047z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D6172A",
    d: "M11 11.732c2.025 0 3.667-1.671 3.667-3.733S13.025 4.266 11 4.266 7.334 5.937 7.334 7.999 8.974 11.732 11 11.732"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#006C3D",
    fillRule: "evenodd",
    d: "M9.429 6.398h1.047v1.067H9.43zm2.095 0h1.048v1.067h-1.048zm0 2.134h1.048v1.066h-1.048zm-2.095 0h1.047v1.066H9.43z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#955DCC",
    fillRule: "evenodd",
    d: "M10.476 6.398h1.048v2.134h-1.048z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeOpacity: 0.1,
    d: "M19.905.535H2.095c-.868 0-1.571.717-1.571 1.6V13.87c0 .883.703 1.6 1.571 1.6h17.81c.868 0 1.571-.717 1.571-1.6V2.134c0-.883-.703-1.6-1.571-1.6Z"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "179a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h22v16H0z"
  })))));
});
const SvgFlagDm = (_ref2, ref) => {
  let {
      title,
      titleId
    } = _ref2,
    props = _objectWithoutProperties(_ref2, _excluded2);
  const {
      className = '',
      color,
      size,
      pointer
    } = props,
    restProps = _objectWithoutProperties(props, _excluded3);
  const isClient = hooks.useOnlyClientRendering();
  const colorClassNameMod = color ? 'am-icon_color-' + color : '';
  const sizeClassNameMod = size ? 'am-icon_size-' + size : '';
  const poinerClassNameMod = pointer ? 'am-icon_pointer' : '';
  const classNames = [className, 'am-icon', colorClassNameMod, sizeClassNameMod, poinerClassNameMod].join(' ');
  if (!isClient) return null;
  return /*#__PURE__*/React.createElement(SVG, _extends({
    className: classNames
  }, restProps));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgFlagDm);
const Memo = /*#__PURE__*/memo(ForwardRef);
export { Memo as ReactComponent };
export default "data:image/svg+xml;base64,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";